import React, { useContext, useMemo } from 'react';
import { DataContext } from '@visx/xychart';
import ImageGraphBackgroundModel from "../../models/background/ImageGraphBackgroundModel.js";
export default function ImageGraphBackground(props) {
  const {
    model
  } = props;
  const cData = useContext(DataContext);
  const {
    theme,
    margin,
    width,
    height,
    innerWidth,
    innerHeight
  } = cData;
  const {
    backgroundColor,
    imageUrl,
    imageWidth,
    imageHeight,
    imageX,
    imageY,
    imageOpacity
  } = useMemo(() => {
    const backgroundColor = ImageGraphBackgroundModel.getBackgroundColor(model) || theme?.backgroundColor || '#fff';
    const imageUrl = ImageGraphBackgroundModel.getImageUrl(model);
    const imageWidth = ImageGraphBackgroundModel.getImageWidth(model);
    const imageHeight = ImageGraphBackgroundModel.getImageHeight(model);
    const imageOpacity = ImageGraphBackgroundModel.getImageOpacity(model) || 100;
    const imageX = ImageGraphBackgroundModel.getImageX(model) || (imageWidth ? width / 2 - imageWidth / 2 : margin.left);
    const imageY = ImageGraphBackgroundModel.getImageY(model) || (imageHeight ? height / 2 - imageHeight / 2 : margin.top);
    return {
      backgroundColor,
      imageUrl,
      imageWidth: imageWidth || innerWidth,
      imageHeight: imageHeight || innerHeight,
      imageX,
      imageY,
      imageOpacity: imageOpacity / 100
    };
  }, [theme?.backgroundColor, innerWidth, innerHeight, model]);

  // early return values not available in context
  if (width == null || height == null || margin == null || theme == null) return null;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: width,
    height: height,
    fill: backgroundColor
  }), /*#__PURE__*/React.createElement("image", {
    opacity: imageOpacity,
    x: imageX,
    y: imageY,
    href: imageUrl,
    width: imageWidth,
    height: imageHeight
  }));
}